
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosataracabs() {



  const cardData =
  {
    keyword: 'Pune to Satara Cabs',
    heading: 'AB Ghule Cabs: Pune to Satara Cabs',
    headingDescription: 'AB Ghule Cabs offers comfortable, reliable, and affordable Pune to Satara cab services for a smooth and enjoyable ride. Whether you are planning a trip for sightseeing, visiting historical landmarks, or exploring nature, our fleet of well-maintained vehicles and professional drivers ensure a safe and pleasant journey. Let us help you experience the beauty of Satara with ease. Pune to Satara is approximately 120 km.',

    top: 'Top Places to Visit in Satara with AB Ghule Cabs',

    topPlaces: [
        {
          title: "Kaas Plateau (Kaas Pathar)",
          description: "Known as the “Valley of Flowers,” Kaas Plateau is a UNESCO World Heritage Site famous for its stunning array of wildflowers. The vibrant colors during the blooming season make it an ideal destination for nature lovers and photographers, offering a breathtaking view of nature’s beauty."
        },
        {
          title: "Rajwada",
          description: "Rajwada, the palace of the Maratha kings, offers a glimpse into Satara’s royal past. The historic structure and its surroundings are a must-visit for history buffs and those interested in architectural heritage, providing a rich experience of Maratha history and culture."
        },
        {
          title: "Sajjangad Fort",
          description: "Sajjangad Fort is a sacred site dedicated to the saint Samarth Ramdas. The fort offers breathtaking views of the surrounding valleys and is a peaceful place for meditation and reflection, making it a serene spot for spiritual rejuvenation."
        },
        {
          title: "Shivaji Maharaj Garden",
          description: "This beautiful garden, located in the heart of Satara, is dedicated to the great Maratha king, Shivaji Maharaj. It’s a perfect spot for a family picnic and a peaceful retreat amidst nature, with lush greenery and a serene environment."
        },
        {
          title: "Thoseghar Waterfall",
          description: "Situated about 20 km from Satara, Thoseghar Waterfall is one of the most scenic spots in the region. The cascading water amidst lush green hills makes it a popular place for nature lovers and adventurers, offering a picturesque view of nature’s grandeur."
        },
        {
          title: "Narayani Dham",
          description: "Narayani Dham is a serene temple dedicated to Goddess Narayani. The peaceful ambiance and the beautiful surroundings make it an ideal spot for spiritual reflection and relaxation, attracting devotees seeking inner peace."
        },
        {
          title: "Bamnoli Lake",
          description: "Bamnoli Lake is a picturesque reservoir surrounded by hills. It is perfect for boating and enjoying the peaceful environment. The lake offers a stunning view of the surrounding landscape, making it an excellent spot for photography and tranquility."
        },
        {
          title: "Yavateshwar Temple",
          description: "This ancient temple, dedicated to Lord Shiva, is located in the tranquil setting of Yavateshwar. The temple is a historical and spiritual site for devotees seeking peace and divine blessings, offering a serene atmosphere for worship and reflection."
        },
        {
          title: "Vajrai Waterfall",
          description: "The Vajrai Waterfall is one of the highest waterfalls in India and offers a mesmerizing view of water cascading down the hills. It is a must-visit spot for nature enthusiasts and adventure seekers, providing an awe-inspiring view of nature's power."
        },
        {
          title: "Koyna Wildlife Sanctuary",
          description: "The Koyna Wildlife Sanctuary, located near Satara, is home to a rich variety of flora and fauna. It is an excellent destination for nature lovers and wildlife enthusiasts interested in bird watching, trekking, and exploring the natural beauty of the region."
        }
      ],


      services: [
        {
          "name": "Pune to Satara Cab Price",
          description: "Travel comfortably from Pune to Satara with AB Ghule Cabs. Our cab prices are competitive and transparent, offering you a reliable ride at affordable rates. Whether you are booking for a one-way trip or a round trip, you can expect clear pricing with no hidden charges."
        },
        {
          "name": "Pune to Satara Cab Service",
          description: "Book a cab service from Pune to Satara with AB Ghule Cabs for a seamless travel experience. We offer a variety of vehicles to suit your preferences and group size. Our professional drivers ensure your journey is smooth, safe, and on time, whether you are traveling for business or leisure."
        },
        {
          "name": "Pune Airport to Satara Taxi Charges",
          description: "The taxi charges from Pune Airport to Satara depend on the vehicle type and travel duration. AB Ghule Cabs provides reasonable and transparent pricing for your airport transfer. We ensure a hassle-free and timely ride from the airport to Satara with all necessary amenities."
        },
        {
          "name": "Pune Airport to Satara Taxi Booking Online",
          description: "Booking a taxi from Pune Airport to Satara is easy with AB Ghule Cabs. Our online booking system allows you to quickly book your ride in just a few steps. Choose from a range of vehicles based on your preferences, and we’ll ensure a smooth airport transfer to Satara."
        },
        {
          "name": "Pune Airport to Satara Car Hire Costs",
          description: "Hiring a car from Pune Airport to Satara is an affordable and convenient option with AB Ghule Cabs. We offer different vehicle options including sedans, SUVs, and luxury cars. The cost depends on your car choice and travel duration, ensuring you get the best value for your trip."
        },
        {
          "name": "Pune Airport to Satara Cab Rental Rates",
          description: "AB Ghule Cabs offers competitive rental rates for your taxi ride from Pune Airport to Satara. Our rates are designed to be budget-friendly, ensuring you have a comfortable ride at a reasonable cost. Rental rates include all necessary charges like tolls and taxes."
        },
        {
          "name": "Pune Airport to Satara One-Way Taxi Fare",
          description: "If you’re traveling from Pune Airport to Satara for a one-way trip, AB Ghule Cabs offers affordable one-way taxi fares. You can enjoy a stress-free ride with no hidden charges. Get in touch with us for an exact fare quote based on your travel time and vehicle preference."
        },
        {
          "name": "Pune Airport to Satara Round Trip Taxi Charges",
          description: "For a round-trip ride from Pune Airport to Satara, AB Ghule Cabs offers flexible pricing. Whether you need a same-day return or a trip with extended hours, our round-trip charges are transparent and competitive. We ensure that your entire journey is comfortable, from pick-up to drop-off."
        },
        {
          "name": "Pune to Satara Cabs",
          description: "AB Ghule Cabs provides reliable and affordable cab services from Pune to Satara. Our fleet includes a range of vehicles to meet your needs, whether you’re traveling solo or with a group. Choose from sedans, SUVs, and luxury cars for a comfortable journey to Satara."
        },
        {
          "name": "Pune to Satara Cab Price",
          description: "The price for a cab from Pune to Satara can vary depending on the vehicle type and your specific travel needs. We offer budget-friendly rates without compromising on comfort and quality of service. The final price is provided upfront during booking, so there are no surprises."
        },
        {
          "name": "Pune to Satara Cab Service",
          description: "Our Pune to Satara cab service is designed to offer comfort and convenience. With well-maintained vehicles and experienced drivers, we ensure a smooth and pleasant trip to Satara. Whether you are visiting for tourism or business, we’re here to provide you with the best travel experience."
        },
        {
          "name": "Pune to Satara One-Way Cab",
          description: "If you need a one-way cab service from Pune to Satara, AB Ghule Cabs offers one-way rides at competitive rates. Enjoy a comfortable ride with our experienced drivers, who ensure you reach your destination safely and on time."
        },
        {
          "name": "Pune to Satara Taxi Service",
          description: "For a reliable taxi service from Pune to Satara, trust AB Ghule Cabs. Our professional drivers are familiar with the best routes to ensure you have a fast and comfortable ride. We offer flexible options for individuals, families, and groups."
        },
        {
          "name": "Pune to Wai Satara Cab Service",
          description: "If you're planning to visit Wai in Satara, AB Ghule Cabs offers specialized cab services for your trip. Wai is a beautiful town, and we ensure that your journey is comfortable, with experienced drivers familiar with the local routes."
        },
        {
          "name": "Pune to Kas Pathar Cab",
          description: "Kas Pathar, also known as the 'Valley of Flowers', is a must-visit for nature lovers. AB Ghule Cabs offers reliable cab services from Pune to Kas Pathar, ensuring you reach this breathtaking location comfortably and on time. Book your cab with us for a stress-free experience."
        },
        {
          "name": "Pune to Kaas Plateau Cab Service",
          description: "Kaas Plateau is a UNESCO World Heritage site and a famous tourist destination near Satara. AB Ghule Cabs provides convenient and affordable cab services from Pune to Kaas Plateau, allowing you to enjoy the beautiful landscapes and rare species of flowers that bloom here."
        },
        {
          "name": "Pune to Satara Cabs Contact Number",
          description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune to Satara Cabs. We ensure a smooth and enjoyable ride for all our customers."
        }
      ],

      tableData: [
        ["Pune to Satara Cab Price", "-Pune to Satara Cab Service"],
        ["Pune Airport to Satara Taxi Charges", "-Pune Airport to Satara Taxi Booking Online"],
        ["Pune Airport to Satara Car Hire Costs", "-Pune Airport to Satara Cab Rental Rates"],
        ["Pune Airport to Satara One-Way Taxi Fare", "-Pune Airport to Satara Round Trip Taxi Charges"],
        ["Pune to Satara Cabs", "-Pune to Satara Cab Price"],
        ["Pune to Satara Cab Service", "-Pune to Satara One Way Cab"],
        ["Pune to Satara Taxi Service", "-Pune to Wai Satara Cab Service"],
        ["Pune to Kas Pathar Cab", "-Pune to Kaas Plateau Cab Service"]
      ],
      
      whychoose: [
        {
          WhyChooseheading: "Comfortable and Hassle-Free Ride",
          WhyChoosedescription: "At AB Ghule Cabs, we ensure that your journey from Pune to Satara is comfortable and stress-free. Our well-maintained, air-conditioned vehicles offer a smooth and relaxing ride, whether you're traveling for business or leisure."
        },
        {
          WhyChooseheading: "Experienced and Professional Drivers",
          WhyChoosedescription: "Our experienced and professional drivers are familiar with the Pune to Satara route and ensure a safe and timely journey. They are trained to provide you with excellent customer service and navigate the roads with ease."
        },
        {
          WhyChooseheading: "Affordable and Transparent Pricing",
          WhyChoosedescription: "We offer competitive and transparent pricing for the Pune to Satara trip, ensuring you get the best value without any hidden charges. Our prices are designed to suit various budgets, and we provide a clear breakdown of the fare before confirming the booking."
        },
        {
          WhyChooseheading: "Timely and Reliable Service",
          WhyChoosedescription: "Timeliness is our priority. Whether you're heading to Satara for a business meeting or a family trip, our drivers ensure that you reach your destination on time. We also offer flexible pick-up and drop-off locations as per your convenience."
        },
        {
          WhyChooseheading: "Safe and Secure Travel",
          WhyChoosedescription: "The safety of our passengers is paramount. All our vehicles are equipped with safety features such as GPS tracking, and our drivers undergo regular training to ensure your safety throughout the journey."
        },
        {
          WhyChooseheading: "Flexible Booking Options",
          WhyChoosedescription: "Booking your Pune to Satara cab is simple and flexible. You can book your ride through our website, mobile app, or by contacting our customer service team for personalized assistance."
        },
        {
          WhyChooseheading: "24/7 Availability",
          WhyChoosedescription: "We provide round-the-clock service, ensuring that you can book your ride at any time, whether it’s early in the morning or late at night."
        }
      ]
      
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a cab from Pune to Satara?',
      answer: 'You can easily book a cab through our website, mobile app, or by calling our customer service team. We offer a simple and convenient booking process.',
    },
    {
      id: 'FAQ2',
      question: 'How long does the journey from Pune to Satara take?',
      answer: 'The distance from Pune to Satara is approximately 110 kilometers, and the journey usually takes around 2.5 to 3 hours, depending on traffic conditions.',
    },
    {
      id: 'FAQ3',
      question: 'What types of vehicles are available for this journey?',
      answer: 'We offer a range of vehicles including sedans, SUVs, and luxury cars to suit your travel needs. All our vehicles are comfortable, well-maintained, and ideal for long-distance travel.',
    },
    {
      id: 'FAQ4',
      question: 'Are there any additional charges for the Pune to Satara trip?',
      answer: 'Our pricing is transparent with no hidden charges. Additional fees may apply for extended hours, detours, or special requests, but we always inform you beforehand.',
    },
    {
      id: 'FAQ5',
      question: 'Can I book a round-trip cab from Pune to Satara?',
      answer: 'Yes, we offer both one-way and round-trip services. You can plan your entire trip and have a comfortable return journey with AB Ghule Cabs.',
    },
    {
      id: 'FAQ6',
      question: 'How do I pay for my Pune to Satara cab ride?',
      answer: 'We offer multiple payment options, including cash, credit/debit cards, or online payments through our website or app.',
    },
    {
      id: 'FAQ7',
      question: 'Are your drivers experienced with the Pune to Satara route?',
      answer: 'Yes, all our drivers are experienced and familiar with the Pune to Satara route, ensuring a safe and smooth journey.',
    },
    {
      id: 'FAQ8',
      question: 'Can I cancel or modify my booking?',
      answer: 'Yes, you can modify or cancel your booking easily through our website or app. If you need assistance, feel free to contact our customer service team.',
    },
    {
      id: 'FAQ9',
      question: 'Do you provide sightseeing assistance in Satara?',
      answer: 'While our drivers are knowledgeable about the route, we do not provide official guides for sightseeing. However, we can recommend places to visit in Satara such as the Kaas Plateau and Sajjangad Fort.',
    },
    {
      id: 'FAQ10',
      question: 'Is AB Ghule Cabs available for local travel within Satara?',
      answer: 'Yes, we offer local travel services within Satara. If you need a cab for sightseeing or exploring the local attractions, we can assist you with that as well.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Amit Deshmukh',
      feedback: 'I used AB Ghule Cabs for my trip to Satara, and I was extremely satisfied. The driver was punctual, the car was clean and comfortable, and the entire journey was smooth. I’ll definitely choose AB Ghule Cabs for future trips!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Priya Mehta',
      feedback: 'I had a wonderful experience with AB Ghule Cabs for my Pune to Satara trip. The driver was friendly and knowledgeable, and the ride was very comfortable. The service was top-notch, and I would highly recommend it to anyone.',
      rating: 5,
    },
  ];
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Satara Cabs | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs</title>
  <meta name="description" content="Book your Pune to Satara Cabs with AB Ghule Cabs. Offering affordable, reliable taxi services and car rentals for one-way, round trip, and luxury taxis. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="Pune to Satara Cab Price, Pune to Satara Cab Service, Pune Airport to Satara Taxi Charges, Pune Airport to Satara Taxi Booking Online, Pune Airport to Satara Car Hire Costs, Pune Airport to Satara Cab Rental Rates, Pune Airport to Satara One-Way Taxi Fare, Pune Airport to Satara Round Trip Taxi Charges, Pune to Satara Cabs, Pune to Satara Cab Price, Pune to Satara Cab Service, Pune to Satara One Way Cab, Pune to Satara Taxi Service, pune to wai satara cab service, pune to kas pathar cab, Pune to Kaas Plateau Cab Service" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Satara Cabs | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs" />
  <meta property="og:description" content="Book your Pune to Satara Cabs with AB Ghule Cabs. Offering affordable, reliable taxi services and car rentals for one-way, round trip, and luxury taxis. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-satara-cabs.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-satara-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Satara Cabs",
        description: "Book your Pune to Satara Cabs with AB Ghule Cabs. Offering affordable, reliable taxi services and car rentals for one-way, round trip, and luxury taxis. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-satara-cabs",
        "logo": "https://abghulecabs.com/images/pune-to-satara-cabs.jpg",
        "image": "https://abghulecabs.com/images/pune-to-satara-cabs.jpg",
        "priceRange": "₹3000 - ₹8000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-satara-cabs",
          "priceCurrency": "INR",
          "price": "3000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "110"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Ravi S"
            },
            "datePublished": "2024-11-15",
            "reviewBody": "AB Ghule Cabs provided us with a very comfortable ride from Pune to Satara. The car was clean, and the driver was very professional. Highly recommend their services!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Priya K"
            },
            "datePublished": "2024-09-30",
            "reviewBody": "We had a wonderful trip to Satara. The driver was courteous, and the taxi was in perfect condition. Great service at a reasonable price!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune to Satara Cabs",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-satara-cabs"
        },
        "keywords": "Pune to Satara Cab Price, Pune to Satara Cab Service, Pune Airport to Satara Taxi Charges, Pune Airport to Satara Taxi Booking Online, Pune Airport to Satara Car Hire Costs, Pune Airport to Satara Cab Rental Rates, Pune Airport to Satara One-Way Taxi Fare, Pune Airport to Satara Round Trip Taxi Charges, Pune to Satara Cabs, Pune to Satara Cab Price, Pune to Satara Cab Service, Pune to Satara One Way Cab, Pune to Satara Taxi Service, pune to wai satara cab service, pune to kas pathar cab, Pune to Kaas Plateau Cab Service"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/31.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetosataracabs;